<template>
  <div class="jobs">
    <top-nav></top-nav>
    <banner :bgImage="bgImage"></banner>
    <div class="aboutReyzarBox">
      <div class="aboutReyzarTit">
        <div class="aboutReyzarTitTop">招聘职位</div>
        <div class="aboutReyzarTitMid" style="letter-spacing: 7px">
          reyzar&nbsp;&nbsp;jobs
        </div>
        <div class="aboutReyzarTitButtom" style="margin-bottom: 30px">
          有意者请发简历至&nbsp;<span>hr@reyzar.com</span>
        </div>
      </div>
      <div class="jobTabTit">
        <ul class="clearfix">
          <li :class="{ current: tab == 1 }" @click="toTab(1)">技术</li>
          <li :class="{ current: tab == 2 }" @click="toTab(2)">销售</li>
          <li :class="{ current: tab == 3 }" @click="toTab(3)">行政</li>
        </ul>
      </div>
      <div class="reyzarJobBox">
        睿哲科技拥有一支年轻的队伍，它为每一位具有相关能力并符合公司文化的人才提供发展机会和平台。在这里你将体验到创业的热情，自由的辩论和思考，以及和众多优秀同事并肩作战和共同进步的机会。
      </div>
      <!-- 技术岗位 -->
      <div class="jobBanner" v-if="tab == 1">
        <div v-if="technicalArr.length !== 0">
          <Carousel v-model="jobValue" loop :height="350">
            <CarouselItem v-for="(item,index) in technicalArr" :key="index">
              <div class="reyzarJobTabBox" v-for="(list,idx) in item" :key="idx">
                <div class="reyzarJobTabTop">
                  <div class="reyzarJobTabName">{{list.name}}</div>
                  <div class="reyzarJobTabEnName">
                    {{list.engName}}
                  </div>
                </div>
                <div class="reyzarJobTabNum">招聘人数：{{list.num}}人</div>
                <div class="reyzarJobTabLine"></div>
                <a
                  :href="list.url"
                  target="_blank"
                  ><div class="reyzarJobTabBtn">查看详情</div></a
                >
              </div>
              <!-- <div class="reyzarJobTabBox">
                <div class="reyzarJobTabTop">
                  <div class="reyzarJobTabName">技术研发经理</div>
                  <div class="reyzarJobTabEnName">
                    Technical Development<br />Manager
                  </div>
                </div>
                <div class="reyzarJobTabNum">招聘人数：1人</div>
                <div class="reyzarJobTabLine"></div>
                <a
                  href="http://jobs.51job.com/guangzhou-thq/77450816.html?s=01&t=0"
                  target="_blank"
                  ><div class="reyzarJobTabBtn">查看详情</div></a
                >
              </div>
              <div class="reyzarJobTabBox">
                <div class="reyzarJobTabTop">
                  <div class="reyzarJobTabName">Java工程师</div>
                  <div class="reyzarJobTabEnName">Java Engineer</div>
                </div>
                <div class="reyzarJobTabNum">招聘人数：5人</div>
                <div class="reyzarJobTabLine"></div>
                <a
                  href="http://jobs.51job.com/guangzhou-thq/75473665.html?s=01&t=0"
                  target="_blank"
                  ><div class="reyzarJobTabBtn">查看详情</div></a
                >
              </div>
              <div class="reyzarJobTabBox">
                <div class="reyzarJobTabTop">
                  <div class="reyzarJobTabName">高级Java工程师</div>
                  <div class="reyzarJobTabEnName">Senior Java Engineer</div>
                </div>
                <div class="reyzarJobTabNum">招聘人数：1人</div>
                <div class="reyzarJobTabLine"></div>
                <a
                  href="http://jobs.51job.com/guangzhou-thq/74101560.html?s=01&t=0"
                  target="_blank"
                  ><div class="reyzarJobTabBtn">查看详情</div></a
                >
              </div>
              <div class="reyzarJobTabBox" style="margin-right: 0">
                <div class="reyzarJobTabTop">
                  <div class="reyzarJobTabName">高级c++<br />软件工程师</div>
                  <div class="reyzarJobTabEnName">
                    Senior c++ Software<br />Engineer
                  </div>
                </div>
                <div class="reyzarJobTabNum">招聘人数：1人</div>
                <div class="reyzarJobTabLine"></div>
                <a
                  href="http://jobs.51job.com/guangzhou-thq/74101152.html?s=01&t=0"
                  target="_blank"
                  ><div class="reyzarJobTabBtn">查看详情</div></a
                >
              </div> -->
            </CarouselItem>

            <!-- <CarouselItem>
              <div class="reyzarJobTabBox">
                <div class="reyzarJobTabTop">
                  <div class="reyzarJobTabName">
                    售前工程师<br /><span>（四川成都公司）</span>
                  </div>
                  <div class="reyzarJobTabEnName">Pre-sale Engineer</div>
                </div>
                <div class="reyzarJobTabNum">招聘人数：1人</div>
                <div class="reyzarJobTabLine"></div>
                <a
                  href="http://jobs.51job.com/guangzhou-thq/82424792.html?s=01&t=0"
                  target="_blank"
                  ><div class="reyzarJobTabBtn">查看详情</div></a
                >
              </div>
              <div class="reyzarJobTabBox">
                <div class="reyzarJobTabTop">
                  <div class="reyzarJobTabName">Linux内核<br />开发工程师</div>
                  <div class="reyzarJobTabEnName">
                    Linux Kernel Development Engineer
                  </div>
                </div>
                <div class="reyzarJobTabNum">招聘人数：2人</div>
                <div class="reyzarJobTabLine"></div>
                <a
                  href="http://jobs.51job.com/guangzhou-thq/80878784.html?s=01&t=0"
                  target="_blank"
                  ><div class="reyzarJobTabBtn">查看详情</div></a
                >
              </div>
              <div class="reyzarJobTabBox">
                <div class="reyzarJobTabTop">
                  <div class="reyzarJobTabName">
                    售前/售后<br />技术支持工程师
                  </div>
                  <div class="reyzarJobTabEnName">Technical support engineer</div>
                </div>
                <div class="reyzarJobTabNum">招聘人数：2人</div>
                <div class="reyzarJobTabLine"></div>
                <a
                  href="http://jobs.51job.com/guangzhou-thq/78434598.html?s=01&t=0"
                  target="_blank"
                  ><div class="reyzarJobTabBtn">查看详情</div></a
                >
              </div>
              <div class="reyzarJobTabBox" style="margin-right: 0">
                <div class="reyzarJobTabTop">
                  <div class="reyzarJobTabName">系统工程师</div>
                  <div class="reyzarJobTabEnName">System Engineer</div>
                </div>
                <div class="reyzarJobTabNum">招聘人数：2人</div>
                <div class="reyzarJobTabLine"></div>
                <a
                  href="http://jobs.51job.com/guangzhou-thq/76388878.html?s=01&t=0"
                  target="_blank"
                  ><div class="reyzarJobTabBtn">查看详情</div></a
                >
              </div>
            </CarouselItem> -->
          </Carousel>
        </div>
        <div v-else class="no-data">
          暂无数据
        </div>
      </div>
      <!-- 销售岗位 -->
      <div class="jobBanner" v-if="tab == 2">
        <div v-if="salesArr.length !== 0">
          <Carousel v-model="salesValue" loop :height="350" arrow="never">
            <CarouselItem v-for="(item,index) in salesArr" :key="index">
              <div class="reyzarJobTabBox" v-for="(list,idx) in item" :key="idx">
                <div class="reyzarJobTabTop">
                  <div class="reyzarJobTabName">{{list.name}}</div>
                  <div class="reyzarJobTabEnName">
                    {{list.engName}}
                  </div>
                </div>
                <div class="reyzarJobTabNum">招聘人数：{{list.num}}人</div>
                <div class="reyzarJobTabLine"></div>
                <a
                  :href="list.url"
                  target="_blank"
                  ><div class="reyzarJobTabBtn">查看详情</div></a
                >
              </div>
              <!-- <div class="reyzarJobTabBox">
                <div class="reyzarJobTabTop">
                  <div class="reyzarJobTabName">销售经理</div>
                  <div class="reyzarJobTabEnName">Sales Manager</div>
                </div>
                <div class="reyzarJobTabNum">招聘人数：3人</div>
                <div class="reyzarJobTabLine"></div>
                <a
                  href="http://jobs.51job.com/guangzhou-thq/74142518.html?s=01&t=0"
                  target="_blank"
                  ><div class="reyzarJobTabBtn">查看详情</div></a
                >
              </div>
              <div class="reyzarJobTabBox">
                <div class="reyzarJobTabTop">
                  <div class="reyzarJobTabName">销售代表</div>
                  <div class="reyzarJobTabEnName">Sales Representative</div>
                </div>
                <div class="reyzarJobTabNum">招聘人数：3人</div>
                <div class="reyzarJobTabLine"></div>
                <a
                  href="http://jobs.51job.com/guangzhou-thq/77402714.html?s=01&t=0"
                  target="_blank"
                  ><div class="reyzarJobTabBtn">查看详情</div></a
                >
              </div> -->
            </CarouselItem>
          </Carousel>
        </div>
        <div v-else class="no-data">
          暂无数据
        </div>
      </div>
      <!-- 行政岗位 -->
      <div class="jobBanner" v-if="tab == 3">
        <div v-if="administrativeArr.length !== 0">
          <Carousel
          v-model="administrativeValue"
          loop
          :height="350"
          arrow="never"
        >
          <CarouselItem v-for="(item,index) in administrativeArr" :key="index">
            <div class="reyzarJobTabBox" v-for="(list,idx) in item" :key="idx">
              <div class="reyzarJobTabTop">
                <div class="reyzarJobTabName">{{list.name}}</div>
                <div class="reyzarJobTabEnName">
                  {{list.engName}}
                </div>
              </div>
              <div class="reyzarJobTabNum">招聘人数：{{list.num}}人</div>
              <div class="reyzarJobTabLine"></div>
              <a
                :href="list.url"
                target="_blank"
                ><div class="reyzarJobTabBtn">查看详情</div></a
              >
            </div>
            <!-- <div class="reyzarJobTabBox">
              <div class="reyzarJobTabTop">
                <div class="reyzarJobTabName">行政主管</div>
                <div class="reyzarJobTabEnName">Administrative Director</div>
              </div>
              <div class="reyzarJobTabNum">招聘人数：1人</div>
              <div class="reyzarJobTabLine"></div>
              <a
                href="http://jobs.51job.com/guangzhou-thq/85395267.html?s=01&t=0"
                target="_blank"
                ><div class="reyzarJobTabBtn">查看详情</div></a
              >
            </div>
            <div class="reyzarJobTabBox">
              <div class="reyzarJobTabTop">
                <div class="reyzarJobTabName">前台文员</div>
                <div class="reyzarJobTabEnName">Reception Clerk</div>
              </div>
              <div class="reyzarJobTabNum">招聘人数：1人</div>
              <div class="reyzarJobTabLine"></div>
              <a
                href="http://jobs.51job.com/guangzhou-thq/86788574.html?s=01&t=0"
                target="_blank"
                ><div class="reyzarJobTabBtn">查看详情</div></a
              >
            </div> -->
          </CarouselItem>
        </Carousel>
        </div>
        <div v-else class="no-data"> 暂无数据 </div>
      </div>

    </div>

    <div class="reyzarPosition">
      <div class="aboutReyzarBox">
        <div class="aboutReyzarTit">
          <div class="aboutReyzarTitTop">公司福利</div>
          <div class="aboutReyzarTitMid" style="letter-spacing: 2px">
            company&nbsp;&nbsp;welfare
          </div>
          <div class="aboutReyzarTitButtom">具有竞争力的薪酬结构和福利体系</div>
        </div>
        <div class="reyzarWelfareTop clearfix">
          <li>
            <div class="reyzarWelfareTit">工作时间</div>
            <div class="reyzarWelfareConn">
              周一至五上午9:00-12:30，下午14:00-18:00；五天7.5小时工作制，周末双休
            </div>
            <div class="reyzarWelfareCircle"><i></i></div>
            <div class="reyzarWelfareStick"></div>
          </li>
          <li>
            <div class="reyzarWelfareTit">带薪假期</div>
            <div class="reyzarWelfareConn">
              享受国家法定节假日、婚假、产假（陪）、病假、丧假、年假等
            </div>
            <div class="reyzarWelfareCircle"><i></i></div>
            <div class="reyzarWelfareStick"></div>
          </li>
          <li>
            <div class="reyzarWelfareTit">福利待遇</div>
            <div class="reyzarWelfareConn">
              入职购买五险一金，午餐补贴，具有竞争力的薪酬，年底双薪+奖金
            </div>
            <div class="reyzarWelfareCircle"><i></i></div>
            <div class="reyzarWelfareStick"></div>
          </li>
        </div>
        <div class="reyzarWelfareTime"></div>
        <div class="reyzarWelfareBottom clearfix">
          <li>
            <div class="reyzarWelfareStick"></div>
            <div class="reyzarWelfareCircle"><i></i></div>
            <div class="reyzarWelfareTit">节假贺礼</div>
            <div class="reyzarWelfareConn">
              每逢重大节日，为员工发放礼品/礼金
            </div>
          </li>
          <li>
            <div class="reyzarWelfareStick"></div>
            <div class="reyzarWelfareCircle"><i></i></div>
            <div class="reyzarWelfareTit">公司活动</div>
            <div class="reyzarWelfareConn">
              公司鼓励员工参加集体活动，定期组织文体活动、聚餐活动
            </div>
          </li>
          <li>
            <div class="reyzarWelfareStick"></div>
            <div class="reyzarWelfareCircle"><i></i></div>
            <div class="reyzarWelfareTit">企业培训及职业发展</div>
            <div class="reyzarWelfareConn">
              新员工入职培训、部门培训、职能培训，广阔的职业发展平台
            </div>
          </li>
        </div>
      </div>
    </div>
    <bottom-footer></bottom-footer>
  </div>
</template>

<script>
import topNav from "@/components/topNav";
import bottomFooter from "@/components/bottomFooter.vue";
import banner from "@/components/banner.vue";

export default {
  name: "jobs",
  data() {
    return {
      listQuery:{
        status:1,
        page:1,
        pageSize:10
      },
      tab: 1,
      bgImage: "../../../static/images/jobBanner.jpg?011801",
      jobValue: 0,
      administrativeValue: 0,
      salesValue: 0,
      showMask: false,
      technicalArr: [
        // {
        //   name: "技术研发经理",
        //   enName: "Technical Development /n Manager",
        //   num: 1,
        //   url: "http://jobs.51job.com/guangzhou-thq/77450816.html?s=01&t=0",
        // },
      
      ],
      salesArr: [
        // {
        //   name: "销售经理",
        //   enName: "Sales Manager",
        //   num: 3,
        //   url: "http://jobs.51job.com/guangzhou-thq/77450816.html?s=01&t=0",
        // },
        // {
        //   name: "销售代表",
        //   enName: "Sales Representative",
        //   num: 3,
        //   url: "http://jobs.51job.com/guangzhou-thq/75473665.html?s=01&t=0",
        // },
      ],
      administrativeArr: [
        // {
        //   name: "行政主管",
        //   enName: "Administrative Director",
        //   num: 1,
        //   url: "http://jobs.51job.com/guangzhou-thq/77450816.html?s=01&t=0",
        // },
        // {
        //   name: "前台文员",
        //   enName: "Reception Clerk",
        //   num: 1,
        //   url: "http://jobs.51job.com/guangzhou-thq/75473665.html?s=01&t=0",
        // },
      ],
    };
  },

  components: {
    topNav,
    bottomFooter,
    banner,
  },

  computed: {},

  mounted() {
    this.getJobsList()
  },

  methods: {
    getJobsList(){
      this.$axios.get('/api/job/findJobs',{params:this.listQuery}).then((res)=>{
        let { list } = res.data.data
        let technicalArr = []
        let salesArr = []
        let administrativeArr = []
        list.forEach((item,index) => {
          if( item.type === 1 ) technicalArr.push(item)
          else if( item.type === 2 ) salesArr.push(item)
          else if( item.type === 3 ) administrativeArr.push(item)

          if( technicalArr.length ===4 )  this.technicalArr.push(technicalArr),technicalArr=[]
          if( salesArr.length ===4 )  this.technicalArr.push(salesArr),salesArr=[]
          if( administrativeArr.length ===4 )  this.administrativeArr.push(administrativeArr),administrativeArr=[]

          if( index == list.length-1  ){
            technicalArr.length !== 0 ? this.technicalArr.push(technicalArr) : ''
            salesArr.length !== 0 ? this.salesArr.push(salesArr) : ''
            administrativeArr.length !== 0 ? this.administrativeArr.push(administrativeArr) : ''
          }
        });
        console.log(this.technicalArr,this.salesArr,this.administrativeArr,'res');
      })
    },
    toTab(num) {
      this.tab = num;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../../assets/css/global";

.no-data{
  width: 100%;
  height: 100%;
  font-size: 28px;
  font-weight: 600;
  background: linear-gradient(to right,#79AAF0,#00ff99);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
}

.jobs {
  .ivu-carousel-arrow.right,.ivu-carousel-arrow.left{
    display: none;
  }
  .aboutReyzarBox {
    width: 1200px;
    height: auto;
    padding: 95px 0;
    margin: 0 auto;
    color: #818181;
    .aboutReyzarTit {
      width: 100%;
      height: auto;
      margin: 0 auto;
      text-align: center;
      .aboutReyzarTitTop {
        width: 100%;
        line-height: 30px;
        text-align: center;
        font-size: 30px;
        letter-spacing: 28px;
        margin-left: 14px;
        margin-bottom: 10px;
      }
      .aboutReyzarTitMid {
        width: 100%;
        line-height: 18px;
        text-align: center;
        text-transform: uppercase;
        font-size: 18px;
        margin-bottom: 20px;
      }
      .aboutReyzarTitButtom {
        width: auto;
        height: 34px;
        line-height: 24px;
        padding-top: 10px;
        font-size: 24px;
        border-top: 1px solid #999a9b;
        display: inline-block;
        margin-bottom: 60px;
        span {
          color: #73a9f1;
          font-size: 24px;
        }
      }
    }
    .jobTabTit {
      width: auto;
      height: 80px;
      position: relative;
      ul {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translate(-50%, 0);
        -ms-transform: translate(-50%, 0);
        -moz-transform: translate(-50%, 0);
        -webkit-transform: translate(-50%, 0);
        li {
          width: 106px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          border: 1px solid #e4e4e4;
          float: left;
          color: #818181;
          font-size: 16px;
          cursor: pointer;
          &.current {
            background-color: #73a9f1;
            color: #fff;
            border: 0;
          }
          &:nth-of-type(1) {
            border-radius: 3px 0 0 3px;
          }
          &:last-of-type {
            border-radius: 0 3px 3px 0;
          }
        }
      }
    }
    .reyzarJobBox {
      width: 720px;
      line-height: 30px;
      font-size: 16px;
      color: #818181;
      text-align: center;
      margin: 0 auto 60px;
    }
    .jobBanner {
      width: 100%;
      min-width: 1200px;
      height: 365px;
      position: relative;
      overflow: hidden;
      padding-top: 0;
      .reyzarJobTabBox {
        width: 220px;
        height: 300px;
        text-align: center;
        color: #818181;
        border: 1px solid #a9a8a8;
        margin-right: 106px;
        padding: 30px 15px;
        float: left;
        &:nth-child(4) {
          margin-right: 0;
        }
        .reyzarJobTabTop {
          width: 100%;
          height: 110px;
          .reyzarJobTabName,
          .reyzarJobTabEnName {
            width: 100%;
    line-height: 24px;
    font-size: 24px;
    text-align: center;
    padding-bottom: 10px;
          }
          .reyzarJobTabEnName {
            line-height: 19px;
    font-size: 16px;
    padding-bottom: 0;
          }
        }
        .reyzarJobTabNum {
          width: 100%;
          height: 26px;
          line-height: 16px;
          text-align: center;
          padding-bottom: 10px;
          font-size: 14px;
        }
        .reyzarJobTabLine {
          width: 44px;
          height: 2px;
          margin: 0 auto;
          background-color: #73a9f1;
        }
        .reyzarJobTabBtn {
          width: 100px;
          height: 34px;
          line-height: 34px;
          font-size: 14px;
          color: #73a9f1;
          text-align: center;
          border: 1px solid #73a9f1;
          border-radius: 17px;
          display: inline-block;
          margin-top: 65px;
        }
        &:hover {
          background: #73a9f1;
          border: none;
          color: #fff;
        }
        &:hover .reyzarJobTabBtn {
          border: 1px solid #fff;
          color: #fff;
        }
        &:hover .reyzarJobTabLine {
          background-color: #fff;
        }
      }
    }
  }
  .reyzarPosition {
    background-color: #f8f8f8;
    width: 100%;
    height: auto;
    color: #818181;
    .aboutReyzarBox {
      width: 1200px;
      height: auto;
      padding: 95px 0;
      margin: 0 auto;
      color: #818181;
      .reyzarWelfareTop,
      .reyzarWelfareBottom {
        width: 100%;
        height: auto;
        li {
          width: 370px;
          padding-right: 90px;
          float: left;
          list-style: none;
          .reyzarWelfareTit {
            width: 100%;
            line-height: 20px;
            font-size: 20px;
            font-weight: bold;
            text-align: center;
          }
          .reyzarWelfareConn {
            width: 100%;
            line-height: 24px;
            height: 48px;
            font-size: 16px;
            text-align: justify;
            margin: 20px 0;
          }
          .reyzarWelfareCircle {
            width: 40px;
            height: 40px;
            border: 1px solid #73a9f1;
            border-radius: 50%;
            margin: 0 auto;
            position: relative;
            i {
              width: 28px;
              height: 28px;
              background-color: #73a9f1;
              border-radius: 50%;
              position: absolute;
              top: 50%;
              left: 50%;
              margin-top: -14px;
              margin-left: -14px;
            }
          }
          .reyzarWelfareStick {
            width: 1px;
            height: 70px;
            background-color: #73a9f1;
            margin: 0 auto;
          }
        }
      }
      .reyzarWelfareTime {
        width: 100%;
        height: 8px;
        background-color: #73a9f1;
        border-radius: 4px;
      }
      .reyzarWelfareBottom {
        padding-left: 90px;
        .reyzarWelfareTit {
          margin-top: 20px;
        }
      }
    }
  }
  .ivu-carousel-dots-inside {
    bottom: -20px !important;
  }
  .ivu-carousel-dots li {
    margin: 0 10px;
  }
  .ivu-carousel-dots li button {
    width: -60px;
  }
  .ivu-carousel-dots li.ivu-carousel-active > button {
    width: 60px;
  }
  .ivu-carousel-dots li button {
    background: #73a9f1;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/jobs/jobs.vue